// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"57":"c91bf294","342":"7e2486f8","744":"7be03d0a","882":"6a4d0c56"}[chunkId] + ".css";
};